// @flow
export const BILLING_INFORMATION_UPDATE_FETCH = 'BILLING_INFORMATION_UPDATE_FETCH'
export const BILLING_INFORMATION_UPDATE_SUCCESS = 'BILLING_INFORMATION_UPDATE_SUCCESS'
export const BILLING_INFORMATION_UPDATE_FAIL = 'BILLING_INFORMATION_UPDATE_FAIL'
